import { Component, h, Prop, Event, EventEmitter, State } from '@stencil/core';
import { i18n } from '../../../utils/i18n';
import AuthHeader from '../auth-header';
import { PianoTerm } from '../types';

const VIDEOS = {
  "free": "https://assets.adsttc.com/piano/videos/illustration-thanks-box.mp4",
  "free_dark": "https://assets.adsttc.com/piano/videos/illustration-thanks-box-d.mp4",
  "essential": "https://assets.adsttc.com/piano/videos/illustration-thanks-door.mp4",
  "essential_dark": "https://assets.adsttc.com/piano/videos/illustration-thanks-door-d.mp4",
  "plus": "https://assets.adsttc.com/piano/videos/illustration-thanks-flower.mp4",
  "plus_dark": "https://assets.adsttc.com/piano/videos/illustration-thanks-flower-d.mp4",
}

@Component({
  tag: 'hd-confirmation',
  shadow: false,
})
export class HdConfirmation {
  @Prop() email: string;
  @Prop() paymentDetails?: { offerId: string, termId: string, term: PianoTerm };
  @Event() nextStep: EventEmitter;
  @State() plan: string;

  t = i18n.get("hd-auth");

  componentWillLoad() {
    if (!this.paymentDetails) {
      this.plan = "free";
    }
    this.plan = this.paymentDetails?.term?.resource?.name?.toLowerCase() === "plus" ? "plus" : "essential";
  }

  nextStepHandler = () => {
    this.nextStep.emit();
  }

  paymentDetailsString = () => {
    const { term } = this.paymentDetails;
    const frequency = term.billingPlanTable[0].period === "month" ? "monthly" : "yearly";
    const startDate = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    const multiSeatString = term.multiSeatCount ? ` for ${term.multiSeatCount} users` : "";
    return this.t('confirmation.purchase_description', { term: term.resource.name, multiSeat: multiSeatString, startDate: startDate, frequency: frequency, price: term.billingPlanTable[0].priceValue, currency: term.chargeCurrency });
  }

  render() {
    return (
      <div class="confirmation-container step-container">
        <AuthHeader
          title={this.t('confirmation.title')}
          subhead={this.t('confirmation.subtitle', { email: this.email || this.t('confirmation.default_email') })}
        />
        <video muted autoplay loop playsInline style={{ height: "230px" }}>
          <source src={VIDEOS[`${this.plan}_dark`]} type="video/mp4" media="(prefers-color-scheme: dark)" />
          <source src={VIDEOS[this.plan]} type="video/mp4" />
        </video>
        {this.paymentDetails && (
          <div class="purchase-summary">
            <h4>{this.t('confirmation.purchase_summary')}</h4>
            <p>{this.paymentDetailsString()}</p>
          </div>
        )}
        <div class="step-actions">
          <button class="next-step" type="submit" onClick={this.nextStepHandler}>
            {this.t('confirmation.button')}
          </button>
        </div>
      </div>
    );
  }
}
